import {Component, OnInit} from '@angular/core';
import {StoreSelectorsService} from "../../services";
import {Compbaser} from "../compbaser";
import {ICartProduct} from "../../interfaces";
import {LocalStoreService} from "../../services";
import {isNullOrUndefOrEmpty} from "../../common";

const {onSaleNow: onSaleNow} = require('../../../../package.json');

@Component({
    selector: 'app-on-sale',
    templateUrl: './on-sale.component.html',
    styleUrls: ['./on-sale.component.scss'],
    standalone: false
})
export class OnSaleComponent extends Compbaser implements OnInit {

    cartProduct: ICartProduct;

    constructor(private storeSelector: StoreSelectorsService, private localStoreService: LocalStoreService) {
        super();
        this.storeSelector.getCartProduct(onSaleNow)
            .subscribe((p) => {
                if (isNullOrUndefOrEmpty(p)) return;
                this.cartProduct = p;
                this.localStoreService.setStorageValConfig('onSaleShown', onSaleNow);
            });
    }

    ngOnInit() {
    }
}


